/* import __COLOCATED_TEMPLATE__ from './delete-history-card.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import ENV from 'bullitt-time-gochips/config/environment';

export default class DeleteHistoryCardComponent extends Component
{
	@tracked isDeletingMonth = false;
	@tracked isDeletingYear = false;
	@tracked monthDeleteResult = null;
	@tracked yearDeleteResult = null;

	get backendUrl()
	{
		const namespace = ENV.gochipsBackendNamespace ? `/${ENV.gochipsBackendNamespace}` : '';
		return `${ENV.gochipsBackendProtocol}://${ENV.gochipsBackendHost}:${ENV.gochipsBackendPort}${namespace}`;
	}

	@action
	async confirmDeleteMonth()
	{
		if (!confirm('Are you sure you want to delete all passings, keypad entries, and statistics (without voltage) older than 1 month? This cannot be undone.')) {
			return;
		}
		await this.deleteOldRecords(1);
	}

	@action
	async confirmDeleteYear()
	{
		if (!confirm('Are you sure you want to delete all passings, keypad entries, and statistics (without voltage) older than 1 year? This cannot be undone.')) {
			return;
		}
		await this.deleteOldRecords(12);
	}

	async deleteOldRecords(olderThanMonths)
	{
		const isMonth = olderThanMonths === 1;
		if (isMonth) {
			this.isDeletingMonth = true;
			this.monthDeleteResult = null;
		} else {
			this.isDeletingYear = true;
			this.yearDeleteResult = null;
		}

		try {
			const response = await fetch(`${this.backendUrl}/deleteHistory`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({ olderThanMonths })
			});

			if (!response.ok) {
				const text = await response.text();
				try {
					const errorData = JSON.parse(text);
					throw new Error(errorData.error || 'Failed to delete records');
				} catch (e) {
					throw new Error(`Server error: ${response.status} ${response.statusText}`);
				}
			}

			const data = await response.json();
			const result = `Deleted ${data.passingsDeleted} passings, ${data.keypadDeleted} keypad entries, and ${data.statisticsDeleted} statistics.`;

			if (isMonth) {
				this.monthDeleteResult = result;
			} else {
				this.yearDeleteResult = result;
			}

		} catch (error) {
			console.error('Error deleting records:', error);
			const errorMsg = `Error: ${error.message || 'Failed to delete records'}`;
			if (isMonth) {
				this.monthDeleteResult = errorMsg;
			} else {
				this.yearDeleteResult = errorMsg;
			}
		} finally {
			if (isMonth) {
				this.isDeletingMonth = false;
			} else {
				this.isDeletingYear = false;
			}
		}
	}
}
